<template>
  <div>
    <div class="dimension-dropdown">
      <MultilayerSingleSelect
        v-model="localSelectedDimension"
        class="key-dropdown"
        name="dimension"
        label="Dimension"
        :optionsList="availableShopperIntelligenceSegments"
        :required="true"
        :small="true"
        :selectAllCheckbox="selectAllCheckbox"
        :hideSectionTitles="true"
        :isCheckboxInactive="isAllSegmentsInactive"
        @input="setDimension"
      >
        <template v-slot:mikmakShopperIntelligence>
          <PersonIcon class="section-icon"/>
          mikmak shopper intelligence
        </template>
      </MultilayerSingleSelect>
      <div class="error-message">{{ noDimensionError }}</div>
    </div>
    <div class="checkbox-container">
      <Checkbox
        class="checkbox"
        v-model="localIncludeFullSegments"
        :disabled="isAllSegmentsSelected"
        @change="$emit('includeFullSegments', localIncludeFullSegments)">
      </Checkbox>
      <div
        class="checkbox-label"
      >
        <div
          class="checkbox-title"
          :class="[{ disabled: isAllSegmentsSelected }]"
        >
          {{ texts.title }}
        </div>
        <div class="checkbox-info">{{ texts.info }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Checkbox, PersonIcon } from '@mikmak/components';
import MultilayerSingleSelect from '../../../../Common/MultilayerSingleSelect.vue';

export default {
  props: {
    selectedDimension: {
      type: String,
      default: '',
    },
    includeFullSegments: {
      type: Boolean,
      default: false,
    },
    availableShopperIntelligenceSegments: {
      type: Array,
      required: true,
    },
    isAllSegmentsInactive: {
      type: Boolean,
    },
  },
  data() {
    return {
      localIncludeFullSegments: this.includeFullSegments,
      localSelectedDimension: this.selectedDimension,
      texts: {
        title: 'Show full segment names',
        info: 'When selected, the full segment names for each demographic value will show. ' +
              'For example, if you chose Occupation as the demographic, ' +
              'a full segment name would be, Demographics > Occupation > Teacher.',
        missingDimensionMessage: 'You must select a dimension',
      },
    };
  },
  computed: {
    ...mapState({
      allSegments: state => state.dashboard.availableReportFields.allSegmentsDimension,
    }),
    selectAllCheckbox() {
      let label = 'Select All Segments';

      if (this.isAllSegmentsInactive) label += ' (Not available)';

      return {
        key: this.allSegments.key,
        value: this.allSegments.value,
        checkboxLabel: label,
      };
    },
    noDimensionError() {
      return !this.localSelectedDimension ? this.texts.missingDimensionMessage : '';
    },
    isAllSegmentsSelected() {
      return this.localSelectedDimension === this.allSegments.value;
    },
  },
  methods: {
    setDimension() {
      this.$emit('input', this.localSelectedDimension);
      this.localIncludeFullSegments =
        this.localSelectedDimension === this.allSegments.value;
      this.$emit('includeFullSegments', this.localIncludeFullSegments);
    },
  },
  components: {
    Checkbox,
    MultilayerSingleSelect,
    PersonIcon,
  },
};
</script>

<style lang="scss" scoped>

.error-message {
  color: #9A2F35;
  font-family: Lato;
  font-style: Regular;
  font-size: 12px;
  height: 17px;
  padding-left: 8px;
}
.dimension-dropdown {
  padding-bottom: 14px;
  width: 450px;
}
.key-dropdown {
  height: fit-content;
}
.checkbox-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.checkbox {
  width: 30px;
  text-align: right;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
}
.checkbox-label {
  width: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding-top: 2px;
  padding-left: 8px;
}
.checkbox-title {
  font-weight: normal;
  font-size: 16px;
  line-height: 100%;
  margin-bottom: 2px;
}
.checkbox-title.disabled {
  color: #778699;
}
.checkbox-info {
  font-size: 12px;
  line-height: 140%;
  color: #778699;
}
</style>
